/**
 * Fetches image with auth (Bearer token) so backend /aed-images/download works.
 * Use for AED images from readisys backend.
 */
import React, { useState, useEffect, useRef } from 'react';
import apiClient from '../utils/api';

export function AuthImage({ src, alt = '', className, ...props }) {
  const [objectUrl, setObjectUrl] = useState(null);
  const [loading, setLoading] = useState(!!src);
  const [error, setError] = useState(false);
  const urlRef = useRef(null);

  useEffect(() => {
    if (!src) {
      setLoading(false);
      return;
    }
    let revoked = false;
    const abort = new AbortController();
    (async () => {
      try {
        setError(false);
        const res = await apiClient.get(src, {
          responseType: 'arraybuffer',
          timeout: 20000,
          signal: abort.signal
        });
        if (revoked) return;
        const blob = new Blob([res.data], { type: res.headers['content-type'] || 'image/png' });
        const url = URL.createObjectURL(blob);
        urlRef.current = url;
        setObjectUrl(url);
      } catch (e) {
        if (!revoked && e.name !== 'CanceledError') setError(true);
      } finally {
        if (!revoked) setLoading(false);
      }
    })();
    return () => {
      revoked = true;
      abort.abort();
      if (urlRef.current) {
        URL.revokeObjectURL(urlRef.current);
        urlRef.current = null;
      }
    };
  }, [src]);

  if (error || !objectUrl) {
    return (
      <div className={`bg-slate-800 flex items-center justify-center text-slate-500 ${className || ''}`} {...props}>
        {loading ? 'Loading…' : 'Image unavailable'}
      </div>
    );
  }

  return <img src={objectUrl} alt={alt} className={className} {...props} />;
}
